import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Link } from 'react-router-dom'

import axios from 'axios';
import swal from 'sweetalert2';
import {bindActionCreators} from 'redux';

import urls from '../../utils/urls';
import helpers from '../../utils/helpers';
import {tokenHeader} from "../../utils/headers";
import {logoutUser} from "../../actions/user_actions";


class Header extends Component {

    constructor(props) {
        super(props);

        this.state = {
            sections: props.sections
        }
    };

    _getHandbook = (ev) => {
        ev.preventDefault();

        let HANDBOOK_URL = `${urls.API_ROOT}/api/v1/documents/handbook/`;
        axios.get(HANDBOOK_URL, tokenHeader())
            .then(response => {
                window.open(`${urls.API_ROOT}${response.data.file}`)
            })
            .catch(() => {
                swal({
                    title: 'Instructivo faltante',
                    html: 'No se ha encontrado un instructivo para su perfil. Por favor, comuníquese con el responsable de la herramienta.',
                    type: 'error'
                });
            })
    };

    render() {
        let user = this.props.user;
        let profile_url = `${urls.API_ROOT}/profile/`;
        let profile_image =  (user && user.profile_image !== null) ? user.profile_image : "/static/images/shell.png";

        let isUserAdmin = helpers.isUserAdmin(user);

        setTimeout(() => {window.initializeDropdowns()}, 500);

        if (user === null) {
            return (<div className={"top-nav"}>
                <div className="nav-wrapper">
                    <div className="row no-margin">
                        <div className="col s12 l10 nav-header futura-bold">
                            <div className="nav-image">
                                <img src="/static/images/shell.png" alt="Shell"/>
                            </div>
                            <div className="nav-title">Fame & Ethanol</div>
                        </div>
                    </div>
                </div>
            </div>);
        }

        let homes = helpers.getUserHomes(user);
        let tripLinks = '';
        if(homes.FE && homes.INTERNAL){
            tripLinks = (
                <div style={{display: 'inline-block'}}>
                    <Link to='/'
                          className={`top-nav-section inline-block ${(this.props.active && this.props.active === helpers.trip_type.FE) ? 'active' : ''}`}>
                        Viajes F&E
                    </Link>
                    <Link to='/internal-trips'
                          className={`top-nav-section inline-block ${(this.props.active && this.props.active === helpers.trip_type.INTERNAL) ? 'active' : ''}`}>
                        Cargas Generales
                    </Link>
                </div>
            );
        }else if(homes.FE){
            tripLinks = (
                <Link to='/'
                      className={`top-nav-section inline-block ${(this.props.active && this.props.active === helpers.trip_type.FE) ? 'active' : ''}`}>
                    Viajes
                </Link>
            );
        }else if(homes.INTERNAL){
            tripLinks = (
                <Link to='/'
                      className={`top-nav-section inline-block ${(this.props.active && this.props.active === helpers.trip_type.INTERNAL) ? 'active' : ''}`}>
                    Viajes
                </Link>
            );

        }

        let canReport = helpers.canUserSeeReports(user);

        return (
            <header>
                <div className={"top-nav"}>
                    <div className="nav-wrapper">
                        <div className="row no-margin">
                            <div className="col s12 l9 nav-header futura-bold">
                                <div className={"col s3"}>
                                    <Link to='/'>
                                        <div className="nav-image">
                                            <img src="/static/images/shell.png" alt="Shell"/>
                                        </div>
                                        <div className="nav-title">Fame & Ethanol</div>
                                    </Link>
                                </div>
                                <div className="col s9">
                                    {tripLinks}
                                    {canReport &&
                                    <Link to='/reports'
                                          className={`top-nav-section inline-block ${(this.props.active && this.props.active === 'reports') ? 'active' : ''}`}>
                                        Reportes
                                    </Link>
                                    }
                                    <a role={"button"} onClick={this._getHandbook}
                                       className={"top-nav-section inline-block"}>Instructivo</a>
                                    {isUserAdmin &&
                                    <Link to='/admin'
                                          className={`top-nav-section inline-block ${(this.props.active && this.props.active === 'admin') ? 'active' : ''}`}>
                                        Administrador
                                    </Link>
                                    }
                                </div>
                            </div>
                            <div className=" col s3 hide-on-med-and-down no-padding-right">
                                <ul className="right main-menu-right no-margin">
                                    <li className={"li-apps-container"}>
                                        <a className='dropdown-button' role={"button"} data-activates='dropdown_apps'
                                           data-beloworigin='true' data-alignment='right' data-propagation='true'
                                           data-constrainwidth='false'>
                                            <i className="material-icons">apps</i>
                                        </a>
                                        <ul id='dropdown_apps' className='dropdown-content doc-dropdown z-depth-0'>
                                            <li className="apps-li-container">
                                                <div className="apps-container">
                                                    {
                                                        user.get_tools && user.get_tools.map((tool) => {
                                                            return (
                                                                <div className="app-container" key={tool.url}>
                                                                    <a href={tool.url} target="_blank">
                                                                        <img src={tool.logo} alt={tool.name}/>
                                                                        <p>{tool.name}</p>
                                                                    </a>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a className="chip dropdown-button user-menu" data-activates="user_menu_drop"
                                           data-beloworigin='true' data-alignment='left' data-propagation='true'>
                                            <img src={profile_image} ref={img => this.img = img} onError={() => this.img.src = "/static/images/shell.png"} alt={user.first_name}/>
                                            <div className="username-container name">
                                                <div className="truncate">{user.first_name}</div>
                                                <div className="truncate">{user.last_name}</div>
                                            </div>
                                        </a>
                                        <ul id="user_menu_drop" className="dropdown-content">
                                            <li>
                                                <a href={profile_url} className="truncate" target="_blank">
                                                    Ir al perfil
                                                </a>
                                            </li>
                                            <li>
                                                <a href='/password-change' className="truncate">
                                                    Cambiar contraseña
                                                </a>
                                            </li>
                                            <li>
                                                <Link to='/logout' className="truncate" style={{fontSize:12}}>
                                                    Cerrar sesión</Link>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        )
            ;
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
};


const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({logoutUser}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/Header/index.js